import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/core/services';
import { AccountService } from '@app/core/services/Common/account.service';
import { MasterdataService } from '@app/core/services/Common/masterdata.service';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import { UserTenantMap } from '@app/shared/models/Authentication/user.model';
import Query from "devextreme/data/query";
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
  selector: 'sa-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.css']
})
export class CompanyInfoComponent implements OnInit {

  businessEntityName: string;
  currency: string;
  dsUserTenantMap: UserTenantMap[] = [];
  suspendValueChagned: boolean;
  isReInsurer = false;
  isBroker = false;
  tenantId: number;
  constructor(private authService: AuthService, private loaderService: NgxUiLoaderService,
    private masterDataService: MasterdataService,
    private accountService: AccountService) { }

  ngOnInit() {
    this.businessEntityName = this.authService.businessEntity.name;
    this.currency = this.authService.currency;
    this.isReInsurer = this.authService.isReInsurer;
    this.isBroker = this.authService.isBroker;
    this.tenantId = this.authService.tenantId;
    this.loadDataSources();

  }
  async loadDataSources() {
    // this.masterDataService.getUserTenants().subscribe(res => {
    //   this.dsUserTenantMap = res;
    // });

    let userId = this.authService.currentUser?.id;
    if (this?.accountService?.getUserTenants?.length > 0) {
      this.prepareDropDown(this?.accountService?.getUserTenants);
      return;
    }

    await this.accountService.getUserTenantMap(userId).subscribe(userTenants => {
      if (userTenants != undefined) {
        this.authService.saveUserTenantMap(userTenants);
        //   this.authService.userTenantMapSubject.next(userTenants);
        this.prepareDropDown(userTenants);
      }
    });
  }

  prepareDropDown(getUserTenants) {
    // let tenantArray = Query(this.accountService.getUserTenants).groupBy("tenantId").toArray();
    let tenantArray = Query(getUserTenants).groupBy("tenantId").toArray();
    tenantArray.forEach((element, i) => {
      var sortedV = Query(element.items).sortBy("tenantName", true).slice(0, 1).toArray();
      this.dsUserTenantMap.push(sortedV[0]);
    });
  }

  onTenantChanged(e: any) {
    // Check if the event is valid
    if (!e || !e.event) return;
  
    e.event.preventDefault();  // Prevent the default action of value change
    console.log('tenant changed');
  
    // if (this.suspendValueChagned) {
    //   this.suspendValueChagned = false;
    //   return;
    // }
  
    var oldValue = e.previousValue;
    var currentValue = e.value;
    var changedTenant = this.dsUserTenantMap.filter(f => f.tenantId == currentValue)[0];
    let text = 'Are you sure you want to change to ' + changedTenant.tenantName + ' market? <br/> If yes, You will be redirected to ' + changedTenant.tenantName;
  
    let dialog = confirm(text, 'Confirm Market change');
  
    dialog.then((dialogResult) => {
      if (dialogResult) {
        // If user confirms, proceed with the value change and API call
        this.loaderService.start();
        e.component.option('value', currentValue); // Manually set the value
      //  this.suspendValueChagned = false;
        this.accountService.switchUserTenant(currentValue).subscribe(res => {
          if (res) {
            this.authService.reLogin();
            notify({ message: 'You have switched ' + changedTenant.tenantName + ' market successfully', width: 500, shading: false }, 'Success', 5000);
          }
          this.loaderService.stop();
        });
      } else {
        // If user cancels, revert the value change
      //  this.suspendValueChagned = true;
        e.component.option('value', oldValue);  // Restore the previous value
      }
    });
  }
  
}
